import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { ErrorLogsFilters } from './interface';
import {
  getErrorLogsAsync,
  getErrorLogAsync,
  deleteErrorLogsAsync,
  getErrorLogsSettingsAsync,
  putErrorLogsSettingsAsync,
  postErrorLogsSettingsRefreshAsync,
} from './asyncActions';

export const errorLogsSlice = createSlice({
  name: 'errorLogs',
  initialState,
  reducers: {
    resetErrorLogDetail: (state) => {
      state.detail.data = null;
      state.detail.status = null;
    },
    setFilters: (state, { payload }: PayloadAction<Partial<ErrorLogsFilters>>) => {
      state.filters = { ...state.filters, ...payload };
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
  extraReducers: (builder) => {
    builder
      // list
      .addCase(getErrorLogsAsync.pending, (state) => {
        state.list.status = 'loading';
      })
      .addCase(getErrorLogsAsync.fulfilled, (state, action) => {
        state.list.status = 'idle';
        state.list.data = action.payload?.item?.items ?? [];
      })
      .addCase(getErrorLogsAsync.rejected, (state) => {
        state.list.status = 'failed';
      })
      // detail
      .addCase(getErrorLogAsync.pending, (state) => {
        state.detail.status = 'loading';
        state.detail.data = null;
      })
      .addCase(getErrorLogAsync.fulfilled, (state, action) => {
        state.detail.status = 'idle';
        state.detail.data = action.payload?.item ?? null;
      })
      .addCase(getErrorLogAsync.rejected, (state) => {
        state.detail.status = 'failed';
      })
      // delete all
      .addCase(deleteErrorLogsAsync.pending, (state) => {
        state.list.deleteStatus = 'loading';
      })
      .addCase(deleteErrorLogsAsync.fulfilled, (state) => {
        state.list.deleteStatus = 'idle';
        state.list.data = [];
      })
      .addCase(deleteErrorLogsAsync.rejected, (state) => {
        state.list.deleteStatus = 'failed';
      })
      // settings get
      .addCase(getErrorLogsSettingsAsync.pending, (state) => {
        state.settings.status = 'loading';
      })
      .addCase(getErrorLogsSettingsAsync.fulfilled, (state, action) => {
        state.settings.status = 'idle';
        state.settings.data = action.payload?.item ?? null;
      })
      .addCase(getErrorLogsSettingsAsync.rejected, (state) => {
        state.settings.status = 'failed';
      })
      // settings put
      .addCase(putErrorLogsSettingsAsync.pending, (state) => {
        state.settings.saveStatus = 'loading';
      })
      .addCase(putErrorLogsSettingsAsync.fulfilled, (state, action) => {
        state.settings.saveStatus = 'idle';
        state.settings.data = action.payload?.item ?? state.settings.data;
      })
      .addCase(putErrorLogsSettingsAsync.rejected, (state) => {
        state.settings.saveStatus = 'failed';
      })
      // settings refresh
      .addCase(postErrorLogsSettingsRefreshAsync.pending, (state) => {
        state.settings.saveStatus = 'loading';
      })
      .addCase(postErrorLogsSettingsRefreshAsync.fulfilled, (state, action) => {
        state.settings.saveStatus = 'idle';
        state.settings.data = action.payload?.item ?? state.settings.data;
      })
      .addCase(postErrorLogsSettingsRefreshAsync.rejected, (state) => {
        state.settings.saveStatus = 'failed';
      });
  },
});

export const { resetErrorLogDetail, setFilters, resetFilters } = errorLogsSlice.actions;

export default errorLogsSlice.reducer;
